import React from 'react';
import {useIntl} from 'react-intl';
import {Container} from 'react-bootstrap';
import {PageTitle} from '../../../_metronic/layout/core';
import ContactCard from '../Components/ContactCard';
import {COMMERCIAL_DIRECTOR, COMMERCIAL_TEAM} from '../Config/contacts';

const ContactsPage = (): JSX.Element => {
  const intl = useIntl();

  return (
    <Container fluid className="px-0">
      <PageTitle
        breadcrumbs={[
          {
            title: intl.formatMessage({id: 'MENU.MY_ACCOUNT'}),
            path: '/my-account',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        {intl.formatMessage({id: 'MENU.MY_CONTACTS'})}
      </PageTitle>

      <div className="card mx-5">
        <div className="card-body py-10">
          <h4 className="text-center text-gray-700 mb-5">
            {intl.formatMessage({id: 'ACCOUNT.CONTACTS.DIRECTION'})}
          </h4>
          <div className="mx-auto" style={{maxWidth: 480}}>
            <ContactCard contact={COMMERCIAL_DIRECTOR} large />
          </div>

          <div className="mx-auto border-start border-gray-400" style={{height: 30, width: 0}} />

          <div className="d-flex align-items-center my-6">
            <div className="border-top border-gray-300 flex-grow-1" />
            <span className="px-4 text-gray-600">
              {intl.formatMessage(
                {id: 'ACCOUNT.CONTACTS.TEAM_UNDER'},
                {name: <strong key="name">{COMMERCIAL_DIRECTOR.name}</strong>}
              )}
            </span>
            <div className="border-top border-gray-300 flex-grow-1" />
          </div>

          <div className="row g-5">
            {COMMERCIAL_TEAM.map((contact) => (
              <div key={contact.name} className="col-12 col-md-6">
                <ContactCard contact={contact} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ContactsPage;
